import {
  UserConsent,
  functional,
  performance,
  targeting
} from "cookiesConsent/domain/consent"

export class SegmentCategories {
  private readonly necessary: boolean
  private readonly performanceGranted: boolean
  private readonly functionalGranted: boolean
  private readonly targetingGranted: boolean

  constructor(
    necessary: boolean,
    performanceGranted: boolean,
    functionalGranted: boolean,
    targetingGranted: boolean
  ) {
    this.necessary = necessary
    this.performanceGranted = performanceGranted
    this.functionalGranted = functionalGranted
    this.targetingGranted = targetingGranted
  }

  forSegment = (): Record<string, boolean> => ({
    C0001: this.necessary,
    C0002: this.performanceGranted,
    C0003: this.functionalGranted,
    C0004: this.targetingGranted
  })

  equals = (other: SegmentCategories): boolean =>
    this.necessary === other.necessary &&
    this.performanceGranted === other.performanceGranted &&
    this.functionalGranted === other.functionalGranted &&
    this.targetingGranted === other.targetingGranted
}

export class SegmentCategoriesFactory {
  fromConsent = (consent: UserConsent): SegmentCategories =>
    new SegmentCategories(
      true,
      consent.permits(performance),
      consent.permits(functional),
      consent.permits(targeting)
    )

  necessaryOnly = (): SegmentCategories =>
    new SegmentCategories(true, false, false, false)
}
